import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getBooking, getConfiguration, getLanguage } from "../../redux/actions";
import AssetUpload from "../AssetUpload";
import "./BigBucket.css";
import { message, Result, Button } from "antd";
import { hasPermissions } from "../../utils/security";

const BigBucket = props => {
  const { languageCode } = props;
  const [permission, setPermission] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const langCode = urlParams.get("language");
  const dispatch = useDispatch();
  const booking = useSelector(state => state.booking);
  const language = useSelector(state => state.language);
  const configuration = useSelector(state => state.configuration);
  const currentMaterialSpecification =
    booking && booking.currentMaterialSpecification;
  const currentUserId = booking && booking.user.id;

  useEffect(() => {
    if(booking) checkPermissions();
  }, [booking]);

  useEffect(() => {
    dispatch(getConfiguration());
    dispatch(getLanguage(languageCode, false, false));
    return () => console.log("cleanup");
  }, []);

  useEffect(() => {
    dispatch(getLanguage(languageCode, false, false));
  }, [languageCode]);

  const setNewAssets = () => {
    const text =
      language && language.data.uploadSuccess
        ? language.data.uploadSuccess
        : "Files succesfully uploaded";
    message.destroy();
    message.success(text, 4);
  };

  const handleError = () => {
    const text =
      language && language.data.uploadError
        ? language.data.uploadError
        : "Upload Error, please try again";
    message.destroy();
    message.error(text, 4);
  };

  const descriptionStyle = {
    zIndex: 9,
    background: "#fff",
    position: "absolute",
    fontSize: "16px",
    padding: "10px",
    width: "100%",
    marginTop: "-5px"
  };

  const checkPermissions = () => {
    hasPermissions(
      "com.ix.adp.model.Asset.create",
      booking.matspecs[0].admaterial[0].status.code,
      val => {
        //console.log("Details checkPermissions: ", val);
        if (val != null) setPermission(val["com.ix.adp.model.Asset.create"]);
      },
      currentUserId
    );
  };
  if (!permission)
    return (
      <div id="bigBucketError">
        <Result
          status="error"
          title={language && language.data.error}
          subTitle={
            language && language.data.bigBucketNotAllowed
              ? language.data.bigBucketNotAllowed
              : "Not allowed"
          }
        />
      </div>
    );
  return (
    <div>
      <p style={descriptionStyle} id="bigBucketDescription">
        {language && language.data.bigBucketDescription}
      </p>
      <div id="bigBucket">
        <div className="file--upload--container">
          <AssetUpload
            loadConfig={configuration}
            materialSpecificationId={currentMaterialSpecification}
            setAsVisual={false}
            translations={language && language.data}
            setNewAssets={setNewAssets}
            handleError={handleError}
          />
        </div>
      </div>
    </div>
  );
};

export default BigBucket;



// WEBPACK FOOTER //
// ./src/components/BigBucket/BigBucket.js